$('.faq-expand-btn').on('click', function() {
    var parent = $(this).parents('.accordion-group');

    parent.find('.accordion-item').each(function() {
        $(this).removeClass('d-none');
    });
    $(this).remove();
});